export enum SaferpayFieldTypeEnum {
  CARDNUMBER = 'cardnumber',
  HOLDERNAME = 'holdername',
  EXPIRATION = 'expiration',
  CVC = 'cvc',
}

export enum SaferpayFieldValidationReason {
  EMPTY = 'empty',
  EXPIRED = 'expired',
  INVALID = 'invalid',
  UNSUPPORTED = 'unsupported',
}

export enum SaferpayFieldsBancontactAppOptionsState {
  LOADING = 'loading',
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export enum SaferpayAltStatusResult {
  CAPTURED = 'CAPTURED',
  FAILURE = 'FAILURE',
  PENDING = 'PENDING',
}
